// lbl.profile
export const profile = {
    firstname: {
        name: 'Firstname',
        placeholder: 'Firstname',
        required: 'Please enter firstname',
        too_short: '',
        invalid: '',
    },
    lastname: {
        name: 'Lastname',
        placeholder: 'Lastname',
        required: 'Please enter lastname',
        too_short: '',
        invalid: '',
    },
    contactNumber: {
        name: 'Contact number',
        placeholder: 'Contact number',
        required: 'Contact number',
        too_short: 'Contact number must be {0} digits',
        invalid: 'Incorrect contact number format',
    },
    email: {
        name: 'Email',
        placeholder: 'Email',
        required: 'Please enter email address',
        too_short: '',
        invalid: 'Incorrect email format',
    },
    idCard: {
        name: 'ID card',
        placeholder: 'ID card',
        required: 'Pleae enter ID card',
        too_short: 'Pleae enter ID card 13 digits',
        invalid: 'ID card invalid',
    },
    password: {
        name: 'Password',
        placeholder: 'Password',
        required: 'Please enter passwrod',
        too_short: '',
        invalid: '',
    },
    gender: {
        name: 'Gender',
        placeholder: 'Please select',
        required: 'Please select gender',
        too_short: '',
        invalid: '',
    },
    birthdate: {
        name: 'Birthdate',
        placeholder: '',
        required: 'Please select birthdate',
        too_short: '',
        invalid: 'Birthdate invalid',
        date: {
            name: '',
            placeholder: 'Day',
            required: ' '
        },
        month: {
            name: '',
            placeholder: 'Month',
            required: ' '
        },
        year: {
            name: '',
            placeholder: 'Year',
            required: ' '
        },
    },
    zipcode: {
        name: 'Zipcode',
        placeholder: 'Zipcode',
        required: 'Please enter zipcode',
        too_short: 'Zipcode must be {0} digits',
        invalid: 'Invalid zipcode',
    },
    subdistrict: {
        name: 'Sub district',
        placeholder: 'Please selece sub-district',
        required: 'Please selece sub-district',
        too_short: '',
        invalid: '',
    },
    district: {
        name: 'District',
        placeholder: 'Please selece district',
        required: 'Please selece district',
        too_short: '',
        invalid: '',
    },
    province: {
        name: 'Province',
        placeholder: 'Please selece province',
        required: 'Please selece province',
        too_short: '',
        invalid: '',
    },

    male: "Male",
    female: "Female",
    notspecified: "Notspecified",

    applyCard: {
        default: 'Apply Card',
        selectBank: 'Select Bank'
    },
    addCard: "Add Card",
    quickMenu: {
        history: "Redeem History",
        applyCard: "Apply Card"
    },
    myCard: "My Card",
    editProfile: "Edit Profile",
    editSuccess: "Edit Profile successfully",
    deleteCardSuccess: "You have successfully <br />Deleted the card",
    confirmDeleteCardTitle: "Confirm Delete Card ?",
    dateOfBirth: "DATE OF BIRTH",
    phoneNumber: {
        default: "Phone Number"
    },
    emailLabel: "E-Mail",
    popupCampaign: {
        title: "Thank you to join <br />JCB Thailand",
        availableQty: "Remaining amount {0} privileges",
    },
    // btnCancelMember: "If you want to cancel membership contact",
    btnCancelMember: "Cancel Member",
    popupCancelMember: {
        title: "Are you sure to cancel membership?",
        msg: "",
        titleSuccess: "Canceled your membership successfully."
    },
    privacySetting: 'Privacy Setting',
    thirdpartySource: {
        title: "REGISTRATION SUCCESSFUL!",
        msg: "TO ENJOY JCB PROMOTIONS, PLEASE ADD A CARD.",
        btnOk: "Add Card",
        btnApply: "Apply Card"
    },
    receivePromotion: {
        title: "YOUR CARD HAS BEEN ADDED",
        msg: "PLEASE WAIT A MOMENT WHILE WE SEND THE PROMOTION VIA LINE MESSAGE",
        btnOk: "OK",
    },
    thirdpartyIsCard: {
        title: "YOUR CARD HAS BEEN ADDED",
        msg: "PLEASE WAIT A MOMENT WHILE WE SEND THE PROMOTION VIA LINE MESSAGE",
        btnOk: "OK",
    },
};
